export const loadState = (state) => {
  try {
    const serializedState = sessionStorage.getItem(state);
    if (serializedState == null) {
      return {};
    }

    // return {};
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

export const saveState = (Key, state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem(Key, serializedState);
  } catch (e) {
    // ignore
  }
};
